import { render, staticRenderFns } from "./skill-detail.vue?vue&type=template&id=527bb1e4&scoped=true&"
import script from "./skill-detail.vue?vue&type=script&lang=js&"
export * from "./skill-detail.vue?vue&type=script&lang=js&"
import style0 from "./skill-detail.vue?vue&type=style&index=0&id=527bb1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527bb1e4",
  null
  
)

export default component.exports